import React, { useState, useEffect } from 'react';
import { Route, Switch} from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./pages1/LandingPage";
import OffsetPage from "./pages1/OffsetPage";
import ImpactPage from "./pages1/ImpactPage";
import { retryWeglotInitializing } from '../common/util/WeglotInitializeUtil';

const App = () => {
  const merchantCode = 'ETIHAD_EY';
  const [fetchedImpact, setfetchedImpact] = useState();
  const [projects, setProjects] =  useState();
  const [currentLang, setCurrentLang] = useState(window.localStorage?.getItem("wglang"));

  useEffect(() => {
    retryWeglotInitializing(50, (lang) => {setCurrentLang(lang)})
  }, []);

  useEffect(() => {
    if (!location?.pathname.includes('impact')){
      project.projects(null, merchantCode, null)
        .then(response => response.json())
        .then(body => setProjects(body))
        .catch(error => {
          setProjects(error);
        })
    }
  }, [])

    useEffect(() => {
      impact.merchants(merchantCode, null, ['flightsImpact'] )
      .then(response => response.json())
      .then(body => {
          setfetchedImpact(body)
      })
      .catch(error => {
        setfetchedImpact(error)
    })
    }, []);

  return (
    <>
{/* (.*) in route path is for matching renders from 'parent/index.js' , a view of selected enterprise pages using 'https://enterprise-subsites.carbon.click'  -  for viewing all pages on the weglot translation service UI  */}
      <Switch >
        <Route
          path="(.*)/impact"
          key="app-etihad-impact"
        >
          <ImpactPage fetchedImpact={fetchedImpact} merchantCode={merchantCode}/>
        </Route>
        <Route
          path={`(.*)/offset`}
          key="app-etihad-offset"
        >
          <OffsetPage projects={projects} fetchedImpact={fetchedImpact} merchantCode={merchantCode}/>
        </Route>
        <Route
          path={`(.*)/`}
          key="app-etihad-landing"
        >
          <LandingPage projects={projects} fetchedImpact={fetchedImpact} merchantCode={merchantCode} lang={currentLang} />
        </Route>
      </Switch>

    </>
  );
}

export default App;
